import { async } from "@/config/fetch";
export default {
    install (Vue) {
        Date.prototype.FormatMy = function (fmt) { //author: meizz 
            var o = {
                "M+": this.getMonth() + 1, //月份 
                "d+": this.getDate(), //日 
                "h+": this.getHours(), //小时 
                "m+": this.getMinutes(), //分 
                "s+": this.getSeconds(), //秒 
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
                "S": this.getMilliseconds() //毫秒 
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o)
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            return fmt;
        }
        //时间戳转换为时间 format('yyyy-MM-dd hh:mm:ss')
        Vue.prototype.formatTime = function (value, format) {
            var timeObj;
            if (value) {
                timeObj = new Date(parseInt(value));
            } else if (value == '') {
                timeObj = new Date();
            } else {
                return;
            }
            var date = {
                "M+": timeObj.getMonth() + 1,
                "d+": timeObj.getDate(),
                "h+": timeObj.getHours(),
                "m+": timeObj.getMinutes(),
                "s+": timeObj.getSeconds(),
                "q+": Math.floor((timeObj.getMonth() + 3) / 3),
                "S+": timeObj.getMilliseconds()
            };
            if (/(y+)/i.test(format)) {
                format = format.replace(RegExp.$1, (timeObj.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            for (var k in date) {
                if (new RegExp("(" + k + ")").test(format)) {
                    format = format.replace(RegExp.$1, RegExp.$1.length == 1 ?
                        date[k] : ("00" + date[k]).substr(("" + date[k]).length));
                }
            }
            return format;
        }

        //时间戳转换为时间 format('yyyy-MM-dd hh:mm:ss')
        Vue.filter("format", function (value, format) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            return Vue.prototype.formatTime(value, format);
        });
        Vue.prototype.clickDateDiff = function (value) {
            const _this = this;
            var result;
            var minute = 1000 * 60;
            var hour = minute * 60;
            var day = hour * 24;
            var halfamonth = day * 15;
            var month = day * 30;
            var now = new Date().getTime();
            var diffValue = parseInt(now) - parseInt(value);
            if (diffValue < 0) {
                return;
            }
            var monthC = diffValue / month;
            var weekC = diffValue / (7 * day);
            var dayC = diffValue / day;
            var hourC = diffValue / hour;
            var minC = diffValue / minute;
            if (monthC >= 1) {
                result = "" + parseInt(monthC) + '月前';
            } else if (weekC >= 1) {
                result = "" + parseInt(weekC) + '周前';
            } else if (dayC >= 1) {
                result = "" + parseInt(dayC) + '天前';
            } else if (hourC >= 1) {
                result = "" + parseInt(hourC) + '小时前';
            } else if (minC >= 1) {
                result = "" + parseInt(minC) + '分钟前';
            } else {
                result = '刚刚';
            }
            return result;
        };
        //时间戳转换为XX天前
        Vue.filter("getDateDiff", function (value) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            return Vue.prototype.clickDateDiff(value);
        });
        //金额保留两位
        Vue.filter("decimal", function (value) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            return parseFloat(value).toFixed(2);
        });
        // 婚姻状况
        Vue.filter("marriage", function (value) { //全局方法 Vue.filter() 注册一个自定义过滤器,必须放在Vue实例化前面
            return value == 1 ? "未婚" : value == 2 ? "已婚" : value == 3 ? "离婚" : value == 4 ? "丧偶" : "";
        });
        // 去除文字和小数点
        Vue.prototype.clearNoNum = function (val) {
            let newValue = "";
            // newValue = val.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
            newValue = val.replace(/[^\d]/g, ""); //清除“数字”以外的字符
            newValue = newValue.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
            newValue = newValue
                .replace(".", "$#$")
                .replace(/\./g, "")
                .replace("$#$", ".");
            newValue = newValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
            if (newValue.indexOf(".") < 0 && newValue != "") {
                //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                newValue = parseFloat(newValue);
            }
            return newValue;
        }

        Vue.prototype.stopScrollFun = function (evt) {
            evt = evt || window.event;
            if (evt.preventDefault) {
                // Firefox
                evt.preventDefault();
                evt.stopPropagation();
            } else {
                // IE
                evt.cancelBubble = true;
                evt.returnValue = false;
            }
            return false;
        }

        //订单计算排序分数
        Vue.prototype.editOrderScore = function (fromData) {
            if (fromData.companyUserId && fromData.orderId) {
                async(
                    "/orderController/calculateOrderScore.do",
                    fromData,
                    "POST"
                )
                    .then((data) => { });
            }
        }

        //提示框
        var repeat = '';
        Vue.prototype.prompt = function (text, time) {
            if (text == repeat) {
                return false;
            }
            repeat = text;
            var time = time || 3000;
            var htm = document.createElement('div');
            htm.innerHTML = text;
            htm.setAttribute('class', "prompt");
            document.body.appendChild(htm);
            setTimeout(() => {
                deletes(htm);
                repeat = '';
            }, time);

            function deletes (htm) {
                htm.style.opacity = 0;
                htm.style.top = htm.offsetTop - 80 + 'px';
                setTimeout(() => {
                    document.body.removeChild(htm);
                }, 600)
            }
        }
        Vue.prototype.isPc = function () {
            var userAgentInfo = navigator.userAgent;
            var Agents = [
                "Android",
                "iPhone",
                "SymbianOS",
                "Windows Phone",
                "iPad",
                "iPod"
            ];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        }
        //JSEncrypt加密
        Vue.prototype.encrypt = function (value) {
            // 实例化一个JSEncrypt对象
            let jse = new this.$jsEncrypt()
            jse.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCsuFef2IzT2GXL6WICnaUrtgjLQM/ZlI9K63c68alSQLZODjHYeSzjUlTZiZILvM2jurbFOMM9/vBJjWxg0m/zynSCYoBFF4xdVkWkwfmx+hahkMGHQcODjERh5nRmNDc00/pLYYSsoXMok+RXUV7Q3fji1JN/0uoM99TjHfasUQIDAQAB')
            // 设置需要加密的字符串
            let encrypted = jse.encrypt(value)
            // 输出加密结果
            return encrypted;
        }

        Vue.prototype.setCookie = function (c_name, value, expiredays) {
            var exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
        };
        Vue.prototype.getCookie = function (name) {
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg))
                // return (arr[2]);
                return unescape(arr[2]);
            else
                return null;
        }
        Vue.prototype.delCookie = function (name) {
            var exp = new Date();
            exp.setTime(exp.getTime() - 1);
            var cval = this.getCookie(name);
            if (cval != null)
                document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
        };
        //前端的加密解密
        Vue.prototype.getAES = function (word) {//加密
            const key = this.$CryptoJS.enc.Utf8.parse("1234123412ABCDEF");  //十六位十六进制数作为密钥
            const iv = this.$CryptoJS.enc.Utf8.parse('ABCDEF1234123412');   //十六位十六进制数作为密钥偏移量
            let srcs = this.$CryptoJS.enc.Utf8.parse(word);
            let encrypted = this.$CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: this.$CryptoJS.mode.CBC, padding: this.$CryptoJS.pad.Pkcs7 });
            return encrypted.ciphertext.toString().toUpperCase();
        }
        Vue.prototype.getDAes = function (word) {//解密
            const key = this.$CryptoJS.enc.Utf8.parse("1234123412ABCDEF");  //十六位十六进制数作为密钥
            const iv = this.$CryptoJS.enc.Utf8.parse('ABCDEF1234123412');   //十六位十六进制数作为密钥偏移量
            let encryptedHexStr = this.$CryptoJS.enc.Hex.parse(word);
            let srcs = this.$CryptoJS.enc.Base64.stringify(encryptedHexStr);
            let decrypt = this.$CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: this.$CryptoJS.mode.CBC, padding: this.$CryptoJS.pad.Pkcs7 });
            let decryptedStr = decrypt.toString(this.$CryptoJS.enc.Utf8);
            return decryptedStr.toString();
        }
    }
}




// WEBPACK FOOTER //
// ./src/config/filter.js